import { apiFetch } from "@/hooks/apiFetch"

export const fetchDiscounts = async (
  { page = 1, searchQuery = "", perPage = 30 },
  signal?: AbortSignal
) =>
  apiFetch(`discount?page=${page}&per_page=${perPage}&search=${searchQuery}`, {
    signal,
  })

export const fetchDiscountById = async (id: number) =>
  apiFetch(`discount/${id}`)

export const createDiscount = async (data: any) =>
  apiFetch("discount", {
    method: "POST",
    body: JSON.stringify(data),
  })

export const updateDiscount = async (id: number, data: any) =>
  apiFetch(`discount/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  })

export const deleteDiscount = async (id: number) =>
  apiFetch(`discount/${id}`, {
    method: "DELETE",
  })

export const attachProductsToDiscount = async (
  discountId: number,
  productIds: number[]
) =>
  apiFetch(`discount/${discountId}/attach-products`, {
    method: "POST",
    body: JSON.stringify({ product_ids: productIds }),
  })

export const detachProductsFromDiscount = async (
  discountId: number,
  productIds: number[]
) =>
  apiFetch(`discount/${discountId}/detach-products`, {
    method: "POST",
    body: JSON.stringify({ product_ids: productIds }),
  })
